/**  主题色配置文件  **/
const baseOptions = {
  '--theme-orange': '#FF9E50',
  '--theme-orange-hover': '#E9AB39',
  '--theme-bg': '#F7F9FA',
  '--theme-dark-bg': '#232832',
  '--theme-text-dark': '#14141E',
  '--theme-text-main': '#50505A',
  '--theme-text-secondary': '#787880',
  '--theme-text-light': '#B4B4BE',
}
export const themeOptions = {
  // R平台 & web
  r: {
    ...baseOptions,
    '--theme-color': '#2DAFCD',
    '--theme-color-sub': '#ABDFEB',
    '--theme-hover-color': '#39E9DB',
    '--theme-select-bg': '#E7F8FA',
    '--theme-border-color': '#D2D7DC',
    '--theme-grey-1': '#282833',
    '--theme-grey-2': '#50525B',
    '--theme-grey-3': '#787A83',
  },

  // G平台
  g: {
    ...baseOptions,
    '--theme-color': '#4897F5',
    '--theme-color-sub': '#B6D5FB',
    '--theme-hover-color': '#6DACF7',
    '--theme-select-bg': '#E9F2FE',
    '--theme-border-color': '#D2D9E3',
    '--theme-grey-1': '#282A2C',
    '--theme-grey-2': '#596370',
    '--theme-grey-3': '#8C97A7',

  },
}
